module.exports = __webpack_public_path__ + "img/gg.8528dbc1.svg";